import { getPersistableState as getPersistableStateForVisitors} from "../Modules/Visitors/Redux/VisitorsPersistence";
import { getPersistableState as getPersistableStateForBookings} from "../Modules/Bookings/Redux/BookingsPersistence";

const localStorageKey = 'locale-portal-state';

export const loadPersistedState = () => {
    try {
        const serializedState = localStorage.getItem(localStorageKey);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
}

export const persistState = (state) => {
    const serializedState = JSON.stringify({
        module: getPersistableStateForModules(state.module ?? {})
    });
    localStorage.setItem(localStorageKey, serializedState)
}

const getPersistableStateForModules = (state) => {
    try {
        const toPersist = {}
        toPersist['BOOKINGS'] = getPersistableStateForBookings(state['BOOKINGS']);
        toPersist['VISITORS'] = getPersistableStateForVisitors(state['VISITORS']);
        return toPersist;
    } catch {
        return {};
    }
}
